import React from "react";
import ReactiveComponent from "@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent";

import { useFlags, useReactifySearchContext } from "../../hooks";

export const SensorPublished: React.FC = () => {
  const flagsHook = useFlags();
  const { options } = useReactifySearchContext();

  if (!flagsHook.flags["reactify-search:flag_sensor_published"]) {
    return null;
  }

  return (
    <ReactiveComponent
      componentId="SensorPublished"
      customQuery={() => {
        if (options.market) {
          return {
            query: {
              bool: {
                must:[{
                  match: {
                    markets: options.market,
                  },
                },{
                  match: {
                    published: true,
                  },
                }]
              },
            },
          };
        }

        return {
          query: {
            match: {
              published: true,
            },
          },
        }
      }}
    />
  );
};
